import MDButton from "components/MDButton";
import React, { useEffect, useState } from "react";
import MDModal from "components/MDModal";
import { RemoveRedEye } from "@mui/icons-material";
import PurchasesDetails from "../BundlepurchaseDetails";
import { useAppServices } from "hook/services";
import localforage from "localforage";
const Default = ({ data }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [apps_data, setapps_data] = useState(false);
  const AppService = useAppServices();
  const getAppconfiguration = async (apps_data) => {
    const loc_data = await localforage.getItem("loc_data");

    const { response } = await AppService.app.getPurchasedBundle({
      query: `bundle_id=${data.purchase_prod.pkg_id}`,
    });
    console.log(response, "getPurchasedBundle");
    if (response) {
      setapps_data(response.data);
    }
  };
  const onLoad = () => {
    getAppconfiguration();
  };
  useEffect(async () => {
    onLoad();
  }, []);
  function AddProduct({ open, onClose, data }) {
    return (
      <MDModal
        open={open}
        onClose={onClose}
        width={"auto"}
        height={"80vh"}
        overflow={"auto"}
      >
        <PurchasesDetails data={data} apps_data={apps_data} />
      </MDModal>
    );
  }
  const closeAddProduct = () => {
    setOpenAddProduct(false);
  };
  return (
    <>
      <RemoveRedEye
        sx={{ cursor: "pointer" }}
        onClick={() => setOpenAddProduct(true)}
      />

      <AddProduct open={openAddProduct} onClose={closeAddProduct} data={data} />
    </>
  );
};

export default Default;
